import { Component, ElementRef, Input, OnChanges, inject } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-icon',
  imports: [NgClass, NgStyle, MatIconModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnChanges {
  private el = inject(ElementRef);
  @Input() icon?: string;
  @Input() width?: number;
  @Input() height?: number;
  @Input() fit?: boolean;
  @Input() rotate?: number;
  @Input() align?: 'left' | 'center' | 'right';
  @Input() color: 'default' | 'primary' | 'secondary' | 'light' | 'black' | 'white' = 'default';

  ngOnChanges(): void {
    if (this.rotate === 90 || this.rotate === 270 || this.rotate === -90 || this.rotate === -270) {
      if (this.height) this.el.nativeElement.style.minWidth = this.height + 'px';
      if (this.width) this.el.nativeElement.style.minHeight = this.width + 'px';
    }
  }
}
